package org.example.site_web.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import org.example.site_web.components.sections.getConsecutiveNumbers
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img


val imageDivStyle = CssStyle.base{
    Modifier
        .position(Position.Relative)
        .width(15.em)
        .height(10.em)
}
val imageStyle = CssStyle.base{
    Modifier.position(Position.Absolute)
        .top(0.px)
        .left(0.px)
        .objectFit(ObjectFit.Fill)
        .width(100.percent)
        .height(100.percent)
}
@Composable
fun ImageFusionViewer(modifier:Modifier=Modifier) {

    val imgA = remember {mutableStateOf("")}
    val imgB = remember {mutableStateOf("")}
    val opacity = mutableStateOf(0.0)
    val maxOpacity = 0.7
    LaunchedEffect(true) {
        var kindex = 0
        imgA.value = "0"
        imgB.value = "1"
        while(true) {
            opacity.value = 0.0
            while (opacity.value <= maxOpacity) {
                opacity.value += 0.05
                delay(100)
            }
            delay(4000)
            val (a,b) = getConsecutiveNumbers(kindex,3)
            kindex=a
            imgA.value = "$a"
            imgB.value = "$b"
        }
    }
    Div(modifier
        .then(imageDivStyle.toModifier())
        .toAttrs()
    ) {
        Img(src = "assets/pics/whoarewe/waw_${imgA.value}.jpg",
            attrs = imageStyle.toModifier()
                .opacity(maxOpacity-opacity.value).toAttrs())
        Img(src = "assets/pics/whoarewe/waw_${imgB.value}.jpg",
            attrs = imageStyle.toModifier()
                .opacity(opacity.value).toAttrs())
    }
}